const semanticClassNames = {
  root: 'social-player-vimeo',
} as const;

export default semanticClassNames;
